export default {
    init() {
      // JavaScript to be fired on the apply-3 page
      $('#have-vehicle').on('click', function() {
        $('.wpcf7-submit').addClass('d-inline-block');
        $('.wpcf7-form').removeAttr('novalidate');
        if($('#no-vehicle').is(':checked')) {
          $('#no-vehicle').prop('checked', false);
          $('#no-vehicle-form').removeClass('d-flex').addClass('d-none');
        }

        if($('#have-vehicle-form').hasClass('d-flex')) {
          $('#have-vehicle-form').removeClass('d-flex').addClass('d-none');
        } else {
            $('#have-vehicle-form').addClass('d-flex');
            $('#have-vehicle-form :input').prop('required', true);
            $('#have-vehicle-form :input').addClass('wpcf7-validates-as-required');
        }
      })

      $('#no-vehicle').on('click', function() {
        $('.wpcf7-submit').addClass('d-inline-block');
        if($('#have-vehicle').is(':checked')) {
          $('#have-vehicle-form').removeClass('d-flex').addClass('d-none');
          $('#have-vehicle').prop('checked', false);
          $('#have-vehicle-form :input').prop('required', false);
          $('#have-vehicle-form :input').removeClass('wpcf7-validates-as-required');
        }
        if($('#no-vehicle-form').hasClass('d-flex')) {
          $('#no-vehicle-form').removeClass('d-flex').addClass('d-none');
        } else {
            $('#no-vehicle-form').addClass('d-flex');
        }
      })

      document.addEventListener( 'wpcf7mailsent', function( event ) {
        setTimeout(function(){
          location = 'https://www.drive4stripes.co.uk/apply-5/';
        }, 2000);  
      }, false );

      $('#cf7mls-next-btn-cf7mls_step-1').prop('disabled', true).addClass('next-step-disabled');

      $('input[name="acceptance-716"]').on('change', function() {
        if(this.checked) {
          $('#cf7mls-next-btn-cf7mls_step-1').prop('disabled', false).removeClass('next-step-disabled');
        } else {
          $('#cf7mls-next-btn-cf7mls_step-1').prop('disabled', true).addClass('next-step-disabled');
        }
      })

      $('#cf7mls-next-btn-cf7mls_step-2').prop('disabled', true).addClass('next-step-disabled');

      $('input[name="acceptance-717"]').on('change', function() {
        if(this.checked) {
          $('#cf7mls-next-btn-cf7mls_step-2').prop('disabled', false).removeClass('next-step-disabled');
        } else {
          $('#cf7mls-next-btn-cf7mls_step-2').prop('disabled', true).addClass('next-step-disabled');
        }
      })

      $('#proof-of-address').on('change', function(){
        $('.file-name-wrapper-proof').append('<li class="listitem1">' + this.files[0].name + '</li>');
      });

      $('#drivers-license').on('change', function(){
        $('.file-name-wrapper-license').append('<li class="listitem1">' + this.files[0].name + '</li>');
      });

      $('#vehicle-photos').on('change', function(){
        $('.file-name-wrapper-car-image').append('<li class="listitem1">' + this.files[0].name + '</li>');
      });

      $('#insurance-docs').on('change', function(){
        $('.file-name-insurance').append('<li class="listitem1">' + this.files[0].name + '</li>');
      });

      $('.final-submit').on('click', function() {
        $('.formSubmissionText').removeClass('d-none');
      })
    },
    finalize() {
      // 
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/apply1.js